module.exports = __webpack_public_path__ + "img/36cba4fd392f73a5f1790cdad2ef0cc3.e4fb96df.jpg";